export default {
  // 模式
  "common.mode.auto": "自发自用",
  "common.mode.economy": "经济模式",
  "common.mode.exigency": "应急模式",

  // 设备
  "common.grid": "电网",
  'common.evChargers': '充电桩',
  'common.evCharger': '充电桩',
  'common.pv': '光伏',
  'common.inverter': '逆变器',
  'common.pcs': '逆变器+电池',
  'common.terminal': '终端设备',
  'common.airc': '空调',
  'common.engine': '发动机',
  'common.battery': '电池',
  'common.metter': '电表',
  'common.other': '其他',
  "common.power": "功率",
  "common.powerTotal": "总功率",
  "common.voltage": "电压",
  "common.electricity": "电量",
  "common.current": "电流",
  "common.homeUsage": "家庭总负载",
  "common.battery.power": "电池功率",

  // 数据
  "common.noDataAvailable": '暂无数据哦~',
  'common.tips': '提示',
  "common.reset": "重置",
  "common.currencyUnit": '¥',
  "common.submiting": '正在提交，请稍候...',
  "common.close": '关闭',
  "common.from": '来自',
  "common.useIn": '用于',
  "common.energyPercent": '能量流占比',
  "common.dataFlow": "数据流",
  "common.getDataIng": '正在获取数据，请稍候...',
  "common.pageLoading": '页面内容正在加载中，请稍候...',
  "common.reseting": "页面内容重置，请稍候...",
  "common.save": '保存',
  "common.onlyNumberTips": "只能填写数字",
  "common.offline": "离线",
  "common.online": "在线",
  "common.fault":"故障",
  "common.charge": "充电",
  "common.discharge": "放电",
  "common.buy": "买入",
  "common.sell": "卖出",
  "common.loadingInfo": '正在加载中，请稍候...',

  // 
  "common.moreFeatures": "更多功能",
  "common.confirm": '确认',
  "common.saveing": "正在保存中，请稍候...",
  "common.searchPlacholder": "请输入搜索关键字",
  "common.iSee": '我知道了',
  "common.pageErrorTips1": "哎呀，网页出错啦~",
  "common.pageErrorTips2": "请尝试刷新一下,或联系客服~",
  "common.refresh": "刷新",
  "common.backToHome": "回到首页",
  "common.checkTips": "正在校验，请稍候...",
  "common.back": "返回",
  "common.cancel": "取消",
  "common.optional": "选填",
  "common.required": "必填",
  "common.status": "状态",
  "common.statusNoDelete": "未删除",
  "common.statusDelete": "已删除",
  "common.submit": '提交',
  "common.disable": "停用",
  "common.enable": "启用",
  "common.year": '年',
  "common.month": '月',
  "common.day": '日',
  "common.version": '版本号：',
  "common.backHome": ' 返回首页',
  "common.backHomeSorry": ' 很抱歉，页面不小心迷路了',
  "common.requestTips1": '数据正在处理，请勿重复提交',
  "common.requestTips2": "系统提示",
  "common.requestTips3": "登录状态已过期，请重新登录",
  "common.requestTips4": "重新登录",
  "common.requestTips5": "无效的会话，或者会话已过期，请重新登录。",
  "common.requestTips6": "服务器异常，请稍后再试。",
  "common.requestTips7": "系统接口请求超时",
  "common.requestTips8": '系统接口',
  "common.requestTips9": '异常',
  "common.iknow": '我知道了',
  "common.logoutSuccess": "退出成功",
  
  // 了解更多组件
  "common.knowMore.title": '想了解更多，请联系北能',
  "common.knowMore.email": '联系邮箱',
  "common.knowMore.phone": '联系电话',
  "common.knowMore.wechat": '联系微信',
  "common.knowMore.website": '官网地址',
  "common.knowMore.address": '联系地址',
  "common.knowMore.addressDetail": '广东省东莞市黄江镇黄京坑清河路8号5栋1205室、1301室',
  
  // 本地连接组件
  "common.localConnection": '本地连接',
  "common.operateInApp": '请在APP中操作!',
  
  "common.enbleStaus": "启用状态",
  "common.battery.status": "不充不放",

  'account.forgetThePassword': '忘记密码',
    'account.logInDirectly': '直接去登录',
    'account.tips1': '页面正在跳转，请稍候...',
    'account.tips2': '请先查看并同意用户须知！',
    'account.autoLogin': '自动登录',
    'account.userLogin': '用户登录',
    'account.registerTips': '还没有账号？点击这里去注册',
    'account.userEmail': '用户名/邮箱',
    'account.userEmailTips': '请输入用户名/邮箱',
    'account.password': '密码',
    'account.passwordTips': '请输入密码',
    'account.submit': '提交',
    'account.submitTips': '提交中,请稍候...',
    'account.otherLoginTips': '或选择其他登录方式',
    'account.userRegistration': '用户注册',
    'account.userName': '用户名',
    'account.userNameTips': '请输入用户名',
    'account.emailTips1': '请输入邮箱地址',
    'account.emailTips2': '邮箱地址格式不正确',
    'account.phone': '电话号码',
    'account.phoneTips1': '请输入电话号码',
    'account.phoneTips2': '电话号码不正确',
    'account.phoneTips3': '请输入电话号码',
    'account.passwordTips1': '请输入6-30位密码',
    'account.passwordTips2': '密码格式不对，密码由英文数字和下划线横线点号自由组成, 长度6-12位',
    'account.passwordTips3': '两次输入密码不一致，请检查并重新输入！',
    'account.passwordTips4': '请输入密码, 密码由英文数字和下划线横线点号自由组成',
    'account.passwordTips5': '确认密码',
    'account.passwordTips6': '请输入确认密码',
    'account.passwordTips7': '两次输入密码不一致，请检查并重新输入！',
    'account.passwordTips8': '请输入确认密码',
    'account.passwordTips9': '恭喜您注册成功！',
    'account.passwordTips10': '您的用户名是：',
    'account.emailIs': '邮箱是：',
    'account.goToLoginPage': 's后将自动跳转到登录页面',
    'account.goLogin': '去登录',
    'account.goRegister': '注册',
    'account.loginSuccess': '登录成功',
    'account.email': '邮箱',
    'account.sologn': '用心打造专属于您的能源方案',
    'account.pleaseAgree': '我已阅读并同意',
    'userAgreement.privacyPolicy': '隐私政策',

    "account.code": "验证码",
    "account.codeTips": "请输入验证码",
    "account.codeTips2": "验证码不正确",
    "account.inviteCodeTips": "请输入邀请码",
    "account.inviteCodeHint": "请联系安装工或运维人员获取邀请码",

    "account.modifyPasswordByAccount": "账号修改密码",
    "account.modifyPasswordByEmail": "邮箱修改密码",
    "account.getPasswordByAccount": "账号找回密码",
    "account.getPasswordByEmail": "邮箱找回密码",

    "account.sendEmailTips": "验证码已发送到邮箱, 请去邮箱查收",
    "account.name": "账号名",
    "account.newPassword": "新密码",
    "account.confirmNewPassword": "确认新密码",
    "account.nameTips": "请输入账号名",
    "account.passwordModifySuccess": "密码修改成功",
    "account.emailCode": "邮箱验证码",
    "account.emailCodeTips": "请输入邮箱验证码",
    "account.emailCodeTips2": "邮箱验证码不正确",
    "account.emailModifySuccess": "密码修改成功",
    "account.passworTips1": "您密码已重置成功！",
    "account.passwordTips11": "请输入确认密码",
    "account.passwordTips12": "请输入新密码",
    "account.nickname": "用户昵称",
    "account.modifyNickname": "修改用户昵称",
    "account.modifyNicknameSuccess": "用户昵称修改成功!",
    "account.nicknameTips": "请输入用户昵称",
    'account.nicknameError': '用户昵称修改失败！',

    "account.login": '登入',
    'account.quickRegister': '快速注册',
    'account.sendCode': '发送验证码',
    'account.sendTips': 's后可重发',
    "account.sendEmailIng": '正在发送邮件，请稍候...',
    'account.emailNotEmpty': '邮箱地址不能为空',
    'account.registerAccount': '注册账号',
    'account.registerWelcome': '欢迎注册 SusprSafe',
    'account.usernameLimit': '用户名只能以字母开头，且只能包含字母、数字、下划线，长度在5-15位之间',

    'copyright.desc2': '网站备案信息：粤ICP备2021169764号',

    'editUserInfo.editUserInformation': '编辑用户信息',
    'editUserInfo.modifyUsername': '修改用户名',
    'editUserInfo.changePictures': '修改头像',
    'editUserInfo.savePicturesSuccess': '用户头像保存成功',
    'editUserInfo.saveError': '保存失败',
    'editUserInfo.pictureLimit':'图片必须小于2M',
    'editUserInfo.uploadPicture':'上传头像',
    'editUserInfo.picturePreview':'预览',
    
    'editUserInfo.bindPhoneNumber': '绑定电话号码',
    'editUserInfo.bindEmail': '邮箱绑定',
    'editUserInfo.changePassword': '密码修改',

    'editUserInfo.notificationSettings': '通知设置',
    'editUserInfo.editAccount': '编辑用户账号信息',
    'editUserInfo.waitBingting': '正在绑定中，请稍候...',
    'editUserInfo.collapse': '收起',
    'editUserInfo.modifyBinding': '修改绑定',
    
    'editUserInfo.emailAddress': '邮箱地址',
    'editUserInfo.tips1': '邮箱绑定成功',
    'editUserInfo.tips2': '保存失败',
    'editUserInfo.tips3': '正在发送邮箱验证码，请稍候...',
    'editUserInfo.tips4': '验证码已经发送到邮箱xxxx，请查收',
    'editUserInfo.tips5': '验证码发送失败！',
    'editUserInfo.tips6': '已经绑定手机号',
    'editUserInfo.tips7': '已经绑定邮箱',
    'editUserInfo.emailTips1': '请输入邮箱地址',
    'editUserInfo.emailTips2': '邮箱地址格式不正确',
    'editUserInfo.emailTips3': 'xxxxs后可重发',
    'editUserInfo.emailTips4': '发送验证码',
    'editUserInfo.emailTips5': '邮箱验证码不能为空',
    'editUserInfo.emailTips6': '邮箱验证码不正确',
    'editUserInfo.emailCode': '邮箱验证码',
    'editUserInfo.save': '保存',

    'editUserInfo.phoneTips1': '手机号码绑定成功',
    'editUserInfo.phoneTips2': '正在发送手机验证码，请稍候...',
    'editUserInfo.phoneTips3': '短信验证码已经发送到手机xxxx，请查收',
    'editUserInfo.phoneTips4': '短信验证码发送失败！',
    'editUserInfo.phoneTips5': '请输入电话号码',
    'editUserInfo.phoneTips6': '电话号码格式不正确',
    'editUserInfo.phoneTips7': '发送短信验证码',
    'editUserInfo.phoneTips8': '短信验证码',
    'editUserInfo.phoneTips9': '手机验证码不能为空',
    'editUserInfo.phoneTips10': '手机验证码不正确',
    'editUserInfo.phone': '电话号码',


    'editUserInfo.noticeTips1': '获取通知配置失败！',
    'editUserInfo.noticeTips2': '通知设置保存成功!',
    'editUserInfo.noticeTips3': '电池电量低通知',
    'editUserInfo.noticeTips4': '充电桩完成通电通知',
    'editUserInfo.errorNotification': '报错通知',
    'editUserInfo.updateNotification': '升级更新通知',
    'editUserInfo.monthlyStatisticsNotification': '月度统计通知',
    'editUserInfo.notificationMethod': '接收方式',

    'editUserInfo.userNameTips1': '用户名保存成功',
    'editUserInfo.userNameTips2': '用户名保存失败',
    'editUserInfo.userNameTips3': '请输入用户名',
    'editUserInfo.userNameTips4': '用户名格式不正确，必须数字下划线英文组成',
    'editUserInfo.userNameTips5': '请输入用户名',
    'editUserInfo.userNameTips6': '正在保存，请稍候...',
    'editUserInfo.userName': '用户名',

    'editUserInfo.avatorTips': '点击修改头像',
    'editUserInfo.verifyCodeTips1': '请输入您收到的验证码：',
    'editUserInfo.verifyCodeTips2': '为了您的账号安全，请点击以下按钮给原手机号发送验证码：',
    'editUserInfo.verifyCodeTips3': '发送验证码',
    'editUserInfo.verifyCodeTips4': '原手机验证通过，请输入新的绑定手机号',
    'editUserInfo.verifyCodeTips5': '为了您的账号安全，请点击以下按钮给原邮箱发送验证码：',
    'editUserInfo.verifyCodeTips6': '原邮箱验证通过，请输入新的邮箱',
    'editUserInfo.verifyCodeTips7': '旧密码',
    'editUserInfo.verifyCodeTips8': '请先绑定邮箱！',
    'editUserInfo.verifyCodeTips9': '验证码已发送到邮箱, 请去邮箱查收',
    "editUserInfo.verifyCodeTips10": '，将自动跳转到登录页面',

    "hems.notice.title": "通知标题", 
   "hems.notice.content": "通知内容", 
   "hems.notice.operate": "操作",
   "hems.notice.noRead": "未读",
   "hems.notice.read": "已读",
   "hems.notice.warning": "提醒",
   "hems.notice.error": "异常",
   "hems.notice.success": "统计结算",
   "hems.notice.sys": "系统信息",
   "hems.notice.operateSuccess": "操作成功",
   "hems.notice.operateTips": "请选择要操作的项",

    // 首页
   "hems.home.selfuseRate": "自发自用率",
   "hems.home.percent": "百分比",
   "hems.home.todayData": "今日数据",
   "hems.home.todayPowerGeneration": "今日发电量",
   "hems.home.salesIncome": "卖电收益",
   "hems.home.saved": "已为你节省",
   "hems.home.reduce": "减少碳足迹",
   "hems.home.tips1": "暂无数据，您还没绑定xxxx",
   "hems.home.criticalLoad": "关键负载",
   "hems.home.keyVoltage": "关键电压",
   "hems.home.householdLoad": "家庭负载",
   "hems.home.householdVoltage": "家庭电压",
   "hems.home.generalLoad": "普通负载",
   "hems.home.generalVoltage": "普通电压",
   "hems.home.batteryHealth": "电池健康度",
   "hems.home.averageTemp": "平均温度",
   "hems.home.gridLoad": "电网负荷",
   "hems.home.toggeleDataSource": "当前展示数据已切换为:",
   "hems.home.toggleTips": "您确定要更换吗？",
   "hems.home.modeSending": "模式指令正在发送中，请稍候...",
   "hems.home.modeSuccess": "模式切换指令已成功发送！",
   "hems.home.isOnline": "是否在线",
   "hems.home.useStatus": "使用状态",
   "hems.home.workModeText": '当前工作模式：',
   "hems.home.toggleDataSourceText": '当前展示数据已切换为：',
   "hems.ev.charge.status": "充电状态",
   "hems.ev.charge.time": "充电时长",
   "hems.ev.charge.count": "实时充电量",
   "hems.ev.charge.status.empty":"空闲",
   "hems.ev.charge.status.ing":"插枪充电中",
   "hems.ev.charge.status.null":"插枪未充电",
   "hems.ev.charge.status.error":"故障",
   "hems.hour":"小时",
   "hems.minue":"分钟",
   "hems.ev.chagre.number": "充电桩编号",

   // User Guide
   "hems.userGuide.selfUse": "自发自用",
   "hems.userGuide.selfUseTips": "优先使用光伏发电，不足时从电网补充",
   "hems.userGuide.economyMode": "经济模式",
   "hems.userGuide.economyModeTips": "根据电价优化用电策略",
   "hems.userGuide.emergencyMode": "应急模式",
   "hems.userGuide.emergencyModeTips": "优先保证关键负载供电",

   // 图表页面
   "hems.history.energyStatistics": "能量统计",
   "hems.history.revenueStatistics": "收益统计",
   "hems.history.greenStatistics": "绿色减排",
   "hems.history.revenueTitle": "卖电总收益",
   "hems.history.savingsTitle": "总节省",
   "hems.history.carbonTitle": "总减少碳排放",
   "hems.history.day": "日",
   "hems.history.month": "月",
   "hems.history.year": "年",
   "hems.history.beforeDay": "前一天",
   "hems.history.afterDay": "后一天",
   "hems.history.beforeMonth": "上一月",
   "hems.history.afterMonth": "后一月",
   "hems.history.beforeYear": "上一年",
   "hems.history.afterYear": "后一年",
   "hems.history.totalUse": '总计使用',
   "hems.history.fullScreen": '全屏',
   "hems.history.timeSelect": "日期选择",
   "sync.tips1": "同步数据指令已经发送成功！",
   "sync.tips2":"数据同步在进行中，因数据量比较大，同步过程需要一点时间，请半个小时后再来查看~",
   "sync.tips3": "设备同步数据有可能延迟，如发现数据异常，请点击：",
   "sync.tips4": "同步数据",

   "charge.info": "充电桩信息",
    "news.loading": '加载中...',
    "news.noMore": '没有更多了',
    "hems.pv.power": '光伏供电量',

  // UEH specific
  "ueh.sellPower": "卖电量",
  
  "menu.home": "首页",
  "menu.history": "历史数据",
  "menu.device": "设备",
  "menu.settings": "设置",
  "menu.messageCenter": "消息中心",
  "menu.help": "帮助与支持",
  "menu.mine": "我的",


  "mine.userSetting": "用户设置",
  "mine.terminalSetting": "终端基础设置",
  "mine.uploadCloud": "数据上云备份",
  "mine.changeVersion": "检查更新",
  "mine.language": "切换语言",
  "mine.about": "关于",
  "mine.feedback": "意见与反馈",
  "mine.logout": "退出登录",
  "mine.logoutAccount": "注销账号",

  "mine.logoutAccountTips": "注销名字为[]的账号",
  "mine.logoutAccountTips1": "注销[]绑定的账号",
  "mine.logoutAccountCare": "申请注销的关联事项：",
  "mine.logoutAccountCare1": "1. 账号处于安全状态",
  "mine.logoutAccountCare1-1": "账号当前为正常使用状态，不存在被盗、违规、禁用等风险。",
  "mine.logoutAccountCare2": "2. 账号授权、绑定关系已解除",
  "mine.logoutAccountCare2-1": "账号已解除与其他第三方平台的授权等。",
  "mine.logoutAccountCare3": "3. 账号注销后不可找回，用户数据均清除",
  "mine.logoutAccountCare3-1": "注销账号后，绑定的手机以及邮箱等账号以及相关数据，均被清除不可找回。",
  "mine.confirmLogout": "确认注销",
  "mine.logoutSuccess": "账号删除成功！",


  "mine.feedbackIssues": "反馈问题",
  "mine.feedQuantity": "数量",
  "mine.feedAmount": "上限9张图片，最大1MB/张",

  "mine.notice.fail": "获取通知配置失败！",
  "mine.notice.saveSuccess": "通知设置保存成功！",
  "mine.notice.saveFail": "保存失败！",
  "mine.notice.title": "通知设置",
  "mine.notice.batteryLow": "电池电量低通知",
  "mine.notice.chargingFinish": "充电桩充电完成通知",
  "mine.notice.error": "报错通知",
  "mine.notice.update": "升级更新通知",
  "mine.notice.monthly": "月度统计通知",
  "mine.notice.receiveType": "接收方式",

  "mine.language.welcome": "欢迎使用SusprSafe",
  "mine.language.desc1": "请依据你所在的地区设置语言版本",
  "mine.language.desc2": "你可以随时通过应用程序的设置进行更改",

  "mine.userInfo.avatar":"头像",
  "mine.userInfo.nickname":"昵称",
  "mine.userInfo.password":"密码",
  "mine.userInfo.changePassword":"修改密码",
  "mine.userInfo.setPassword":"设置密码",
  "mine.userInfo.phoneNumber":"电话号码",
  "mine.userInfo.bindPhone":"绑定电话号码",
  "mine.userInfo.bindEmail":"绑定邮箱",
  "mine.loginExpired":"登录过期，请重新登录",
  "mine.userInfo.title":"用户信息",
  "mine.userInfo.bind":"绑定",
  "mine.userInfo.modify": "修改",
  "mine.userInfo.modifyNickname":"修改昵称",
  "mine.userInfo.userNickname":"用户昵称",
  "mine.userInfo.selectPic":"请选择上传的图片",
  "mine.userInfo.saveSuccess":"保存成功",
  "mine.userInfo.uploadFail":"上传失败",
  "mine.userInfo.avatarSaveSuccess":"头像保存成功",
  "mine.userInfo.nameTips1":"用户昵称不能为空",
  "mine.userInfo.nameTips2":"请输入用户昵称",

  "common.pleaseSelect": "请选择",
  "question.commonQuestions": "常见问题",
  "account.toggleLanguage": '切换语言',
  "account.localConnection": "本地连接",
  "account.selectLanguage": '请选择语言',
  "account.sendEmailToast": "验证码已发送到邮箱xxx, 请去邮箱查收",
  "account.emailError": "邮箱格式不正确",
  "account.sendEmailFail": "发送失败，请重试",
  
  "common.submitting": "正在提交中， 请稍候...",

  "device.page.noData": "暂无数据, 此页面需在app中才能预览",


  // OTA Upgrade
  "bmsFirmware.upgrade": "升级",
  "bmsFirmware.upgrading": "升级中...",
  "bmsFirmware.uploadingFile": "正在上传固件文件...",
  "bmsFirmware.upgradingProgress": "正在升级固件... {progress}%",
  "bmsFirmware.upgradeSuccess": "升级成功",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS固件升级完成！",
  "bmsFirmware.upgradeFailed": "升级失败",
  "bmsFirmware.upgradeFailedFormError": "请检查表单填写是否正确",
  "bmsFirmware.upgradeFailedNetworkError": "网络异常，请重试",
  "bmsFirmware.invalidFileType": "请选择有效的固件文件 (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "请先选择固件文件",
  "bmsFirmware.statusUpgrading": "升级中",
  "bmsFirmware.statusCompleted": "升级完成",
  "bmsFirmware.statusFailed": "升级失败",
  "bmsFirmware.deviceUpgrading": "正在升级固件包, 升级时间在30 ~ 50 分钟，期间无法查看设备实时数据，请等待...",
  "bmsFirmware.upgradeStatusLabel": "升级状态",
  "bmsFirmware.upgradeProgressLabel": "升级进度",
  "bmsFirmware.currentPackageLabel": "当前已传输的数据包序号",
  "bmsFirmware.totalPackagesLabel": "总数据包数量",
  "bmsFirmware.upgradeFailedCheckDevice": "请检查设备状态，并重新尝试升级",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "设置成功",
  "settingResult.defaultSubTitle": "参数设置已保存",
  "settingResult.confirmButton": "确定",

 
};